import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  HomepageContent,
  SectionId,
} from '@wix/wix-help-widget-common/homepage';

import { experiments } from '../../experiments/client';
import { getHomepageContent } from '../../homepage/api';
import { clientSdk } from '../ClientSDK';
import { helpCenterService } from '../services/helpCenter';

export const loadHomepageContent = createAsyncThunk<HomepageContent>(
  'loadHomepageContent',
  async () => {
    const provideFromSDK = helpCenterService.provideRuntimeDataFromSDK;
    const homepageContent = provideFromSDK
      ? await clientSdk.getHomepageContent()
      : await getHomepageContent();

    // TODO: Remove once requestSuccessManager is open.
    if (
      experiments.is('specs.chatbot.requestSuccessManager', 'false') &&
      homepageContent?.sections.length
    ) {
      homepageContent.sections = homepageContent.sections.filter(
        (section) => section.sectionId !== SectionId.RequestSuccessManager,
      );
    }

    return homepageContent;
  },
);
